/**
 * 全局路由策略：
 * 跳转路由，如果不存在匹配路由，自动向主站跳转
 */
const excludeRedirectPaths = ['/about', '/partner', '/nft', '/BWTC', '/p2p', '/academy', '/vip', '/messages', '/vip-portal', '/BMXstaketolist','/cards'];

export default defineNuxtRouteMiddleware(async (to, from) => {
  // const router = useRouter();
  if (!process.client) {
    return;
  }
  // 开发环境不要做这个跳转，影响调试
  if (process.env.NODE_ENV === 'development') return;
  const { $curHost = {} } = useNuxtApp();
  if (to.path) {
    // console.log('to >>>', !excludeRedirectPaths.some((path) => to.path.startsWith(path)))
    if (!excludeRedirectPaths.some((path) => to.path.startsWith(path))) {
      // 跳转路径不属于本站展示内容 ==> 重定向通过nginx重新获取资源文件
      console.log('=== nuxt3 Redirect===', `${window.location.origin}${to.fullPath}`);
      const pre = window.location.origin;
      window.location.href = `${pre}${to.fullPath}`;
      throw new Error('ERR_REDIRECT');
      // return await navigateTo(`${$curHost?.origin}${to.fullPath}`, {
      //   external: true,
      //   redirectCode: 200,
      // });
    }
    // if (to.name && !router.hasRoute(to.name)) {
    //   return await navigateTo(`${runtimeConfig.public.MASTER_HOST}${to.fullPath}`, {
    //     external: true,
    //     redirectCode: 200,
    //   });
    // }
  } else {
    return await navigateTo(`${$curHost?.origin}${to.fullPath}`, {
      external: true,
      redirectCode: 200,
    });
  }
  // console.log('router-policy.global', to)
  // const auth = useState('auth')
  // if (!auth.value.authenticated) {
  //   return navigateTo('/login')
  // }
});
